// Imports
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';
import lazySizes from 'lazysizes';
import { initializeStars }  from './parallaxStars.js';
import gsap from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swup from 'swup';
import './disableCookies.js';


gsap.registerPlugin(ScrollTrigger);




// Alpine.js Setup 🏔️
window.Alpine = Alpine;
Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.start();

// Global Variables 🌍
const nav = document.querySelector('.nav');
const navLogo = document.querySelector('.nav__logo');
const body = document.body;
const main = document.querySelector('main');
const navElement = document.querySelector('.nav .nav__logo');
const bannerHome = document.querySelector('.banner--home');
const isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;

// Utility Functions 🛠️
const easeInOutQuad = (t) => t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
const easeInCubic = (t) => t * t * t;
const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

const isNavAtTop = () => nav.getBoundingClientRect().top <= 100;

const scrollToElement = (element, duration, easingFunction) => {
  const start = window.scrollY;
  const end = element.getBoundingClientRect().top + window.scrollY;
  const distance = end - start;
  let startTime = null;

  const animation = (currentTime) => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    const easedProgress = easingFunction(progress);

    window.scrollTo(0, start + distance * easedProgress);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  };

  requestAnimationFrame(animation);
};




function initAniatmions() {

ScrollTrigger.batch(".f-up", {
  onEnter: (elements, triggers) => {
    gsap.to(elements, { opacity: 1, y: 0,  stagger: 0.15 });
    // console.log(elements.length, "elements entered");
  }
});

gsap.to("form", {
  opacity: 1,
  y: 0,
  stagger: 0.15,
  duration: 0.5, // adjust as needed
  ease: "power2.out"
});

gsap.to(".banner__button", {
  y: 0,
  duration: 0.5,
  ease: "power2.out"
});



}

// For navigation
ScrollTrigger.batch(".f-down", {
  onEnter: (elements, triggers) => {
    gsap.to(elements, { opacity: 1, y: 0,  stagger: 0.15 });
    // console.log(elements.length, "elements entered");
  }
});



// Set Active Navigation Link 🔗
function setActiveNav() {
  const nav = document.querySelector('#nav');
  if (!nav) return;

  const currentSlug = window.location.pathname.replace(/\/$/, '');
  const navLinks = nav.querySelectorAll('.nav__link a');


  navLinks.forEach(link => {
    const linkSlug = link.getAttribute('href').replace(/\/$/, '');

    if (currentSlug === '') {
      link.classList.remove('active');
    } else if (linkSlug.includes(currentSlug)) {
      link.classList.add('active');
    } else {
      link.classList.remove('active');
    }
  });
}

// Initialize everything 🏁
function init() {

  console.log('init');

  checkHomePage();
  checkBanner();
  lazySizes.init();  
  initAniatmions();
  initializeStars();
  addScrollEffects();
  removeBr('h1');

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
    // initAniatmions();
  } else {
    console.error('GSAP and/or ScrollTrigger not loaded');
  }


  document.querySelectorAll('img.lazyloaded').forEach(img => {
    img.classList.remove('blur-up');
  });

  if (document.querySelectorAll('nav')) {
    console.log('🧭 Main navigation exists');
    setActiveNav();
  }

  if (document.querySelector('.maps')) {
    console.log('🗺️ Map exsists exists');
    initializeMap();
  }

}


document.addEventListener('DOMContentLoaded', () => {
  init();
});

// Check if on Home Page 🏠
const checkHomePage = () => {
  if (window.location.pathname === '/' || window.location.href === window.location.origin + '/') {
    body.classList.add('body--home');
  } else {
    body.classList.remove('body--home');
  }
};


function initializeMap() {
  // Check if there are any elements with the class .maps

   if (typeof mapboxgl === 'undefined') {
    const script = document.createElement('script');
    script.src = "https://api.mapbox.com/mapbox-gl-js/v2.3.1/mapbox-gl.js"; // Use the appropriate Mapbox version
    script.onload = initializeMap; // Retry initializing map after script loads
    document.head.appendChild(script);
    return;
  }

  if (!document.querySelector('.maps')) return;
  // Mapbox here we go 🗺️
  let map;
  mapboxgl.accessToken = "pk.eyJ1IjoidHJlYm9ycG9zdCIsImEiOiJjbTJlamVkZXUxNTM5MmpzZjI0NXByMGR3In0.eyUelyU0O9ya1NK0cyQ_3Q";

  map = new mapboxgl.Map({
    container: "embedded-map-9a5bf060-7f5b-47a3-bce7-dc8d3d0e416c",
    style: "mapbox://styles/mapbox/light-v10",
    center: [-6.251874143679147, 53.336056953068415],
    zoom: 16
  });

  let elMarkerc7cadfef = document.createElement("div");
  elMarkerc7cadfef.className = "marker";
  elMarkerc7cadfef.style.backgroundImage = `url(${window.location.origin}/assets/svg/marker.svg)`;
  elMarkerc7cadfef.style.width = "27px";
  elMarkerc7cadfef.style.height = "39px";
  elMarkerc7cadfef.style.backgroundSize = "100%";
  elMarkerc7cadfef.style.zIndex = "333";

  let objMarkerc7cadfef = new mapboxgl.Marker({
    anchor: "bottom",
    element: elMarkerc7cadfef
  });
  objMarkerc7cadfef.getElement().id = "marker";
  objMarkerc7cadfef.setLngLat([-6.251895601351142, 53.33606976588133]);
  objMarkerc7cadfef.addTo(map);
}



document.addEventListener("swup:contentReplaced", function () {
  console.log('content has been replaced');

  if (!document.getElementById("embedded-map-9a5bf060-7f5b-47a3-bce7-dc8d3d0e416c")) {
    initializeMap();
  }
});




// Initialize Swup 🚀
const swup = new Swup();

// Swup Hooks ⚡
swup.hooks.on('visit:start', () => {
  // Add 'changing' class to each star
  // document.querySelectorAll(".star").forEach(star => {
  //   gsap.to(star, { opacity: 0, y: 50, duration: 0.2 });
  // });

  // Update HTML classes
  document.documentElement.classList.add("loading");
  document.documentElement.classList.remove("loaded");

  // Delay transition by 1 second
  return new Promise((resolve) => setTimeout(resolve, 250));
});


swup.hooks.on('page:view', () => {
  document.documentElement.classList.add("loaded");
  document.documentElement.classList.remove("loading");
  init(); // Call your init function if you have additional setup
});

function checkBanner() {
  const banner = document.querySelector('.banner');
  if (!banner) {
      nav.classList.add('nav--no-banner');
  } else {
    nav.classList.remove('nav--no-banner');
  }
}



if (lazySizes) {
  console.log("Lazysizes module imported successfully:", lazySizes);
} else {
  console.log("Lazysizes module is not available");
}


document.addEventListener("DOMContentLoaded", () => {
  if (window.lazySizes) {
      console.log("Lazysizes is loaded");
  }
});


function addScrollEffects() {
  const speeds = [];
  const stars = gsap.utils.toArray(".star");
  
  // Generate unique parallax speeds for each star
  stars.forEach((star, index) => {
    // Create a unique speed for each star, with more variation
    // const baseSpeed = (index % 2 === 0 ? -1 : 1) * (Math.random() * 450 + 20);
    // speeds.push(baseSpeed);
  });

  // Batch fade-in effect
  ScrollTrigger.batch(".star", {
    // onEnter: (elements) => {
    //   gsap.to(elements, { 
    //     opacity: 0.8, 
    //     y: 50, 
    //     stagger: 0.15,
    //     duration: 1,
    //     ease: "power2.out"
    //   });
    // },
  });

  // Individual parallax for each star
  stars.forEach((star, index) => {
    gsap.to(star, {
      yPercent: speeds[index], // Use pre-calculated unique speed
      ease: "none",
      scrollTrigger: {
        trigger: star,
        start: "top bottom",
        end: "bottom top",
        scrub: true // Smooth parallax effect
      }
    });
  });
}







function removeBr(el) {
  if (window.innerWidth <= 768) {
      const item = document.querySelector(el);
      console.log(item);
      if (item) {
          item.innerHTML = item.innerHTML.replace(/<br\s*\/?>/gi, " ");
      }
  }
}


document.addEventListener('DOMContentLoaded', () => {
  
removeBr('h1');
});



